import axios from "@/http";
import { handleGetRequestParams } from '@/common/js/util'

class ProductionWorkbench {
  /* 人效数据 */
  static getHumanEfficiencyData(option) {
    let url = `/oa/api/operation/workbench/order/num/ratio?`;
    url += handleGetRequestParams(option)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 统计数据 */
  static getStatisticsData(option) {
    let url = `/oa/api/production/workbench/info?`;
    url += handleGetRequestParams(option)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default ProductionWorkbench;